import { BaseAction } from './BaseAction';

export enum BillingActions {
  SyncSubscriptionStatus = '[Billing] Sync Subscription Status',
  SyncSubscriptionStatusSucceeded = '[Billing] Sync Subscription Status Succeeded',
  SyncSubscriptionStatusError = '[Billing] Sync Subscription Status Error',
  RefreshSubscriptionStatus = '[Billing] Refresh Subscription Status',
  RefreshSubscriptionStatusSucceeded = '[Billing] Refresh Subscription Status Succeeded',
  RefreshSubscriptionStatusError = '[Billing] Refresh Subscription Status Error',
}

export class SyncSubscriptionStatus implements BaseAction<BillingActions> {
  readonly type = BillingActions.SyncSubscriptionStatus;

  constructor(public readonly hostedPageId: string) {}
}

export class SyncSubscriptionStatusSucceeded implements BaseAction<BillingActions> {
  readonly type = BillingActions.SyncSubscriptionStatusSucceeded;
}

export class SyncSubscriptionStatusError implements BaseAction<BillingActions> {
  readonly type = BillingActions.SyncSubscriptionStatusError;

  constructor(public readonly error: string) {}
}

export class RefreshSubscriptionStatus implements BaseAction<BillingActions> {
  readonly type = BillingActions.RefreshSubscriptionStatus;

  constructor(public readonly subscriptionId: string, public readonly orgId: number) {}
}

export class RefreshSubscriptionStatusSucceeded implements BaseAction<BillingActions> {
  readonly type = BillingActions.RefreshSubscriptionStatusSucceeded;
}

export class RefreshSubscriptionStatusError implements BaseAction<BillingActions> {
  readonly type = BillingActions.RefreshSubscriptionStatusError;

  constructor(public readonly error: string) {}
}

export type BillingAction = SyncSubscriptionStatus | SyncSubscriptionStatusSucceeded | SyncSubscriptionStatusError
  | RefreshSubscriptionStatus | RefreshSubscriptionStatusSucceeded | RefreshSubscriptionStatusError;
